module.exports = __webpack_public_path__ + "img/178.vegetarian.8a7c9a1d.svg";